export const chartColumns = [
  {
    field: 'approvalDate',
    title: '审批时间',
  },
  {
    field: 'operatorName',
    title: '审批人',
  },
  {
    field: 'changeDate',
    title: '部门',
  },
  {
    field: 'feedback',
    title: '反馈意见',
  },
  {
    field: 'approvalStatus',
    title: '审批状态',
  },
];
